import React from 'react';
import { List, ListItem } from 'material-ui';
import FileDownload from 'material-ui/svg-icons/file/file-download';

export default function Attachments({ attachments }) {
    return (
        <div className='attachments'>
            <span className='name'>Attachments</span>
            <div className='list'>
                {
                    attachments && attachments.map(attachment => {
                        const url = `/api/v1/file/${attachment._id}`;
                        return (
                            <a className='item' key={attachment._id} href={url} download>
                                <div>
                                    <FileDownload className='icon' color='#757575' />
                                </div>
                                <span className='name'>{attachment.name}</span>
                            </a>
                        );
                    })
                }
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/Attachments.jsx